// external
import React from 'react';

// models and services
import LiteralsService from 'src/services/literals/LiteralsService';

// components
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// styles
import colors from 'src/styles/colors.module.scss';
import styles from './whyYouShouldConnectTooltip.module.scss';
import MoreInfoTooltip from 'src/components/more-info-tooltip/MoreInfoTooltip';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';

const tooltip = (
    <MoreInfoTooltip
        className={styles.tooltipContainer}
        buttonAriaLabel={LiteralsService.getLiteral('Onboarding.connectAccounts.whyShouldYouConnect')}
        body={
            <>
                <Typography variant={TypographyVariants.HEADING_XS} component="p" className={colors.brand}>
                    {LiteralsService.getLiteral('Onboarding.connectAccounts.header')}
                </Typography>
                <ul>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT}>
                            {LiteralsService.getLiteral('Onboarding.connectAccounts.bullets[0]')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT}>
                            {LiteralsService.getLiteral('Onboarding.connectAccounts.bullets[1]')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT}>
                            {LiteralsService.getLiteral('Onboarding.connectAccounts.bullets[2]')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT}>
                            {LiteralsService.getLiteral('Onboarding.connectAccounts.bullets[3]')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT}>
                            {LiteralsService.getLiteral('Onboarding.connectAccounts.bullets[4][0]')}
                            <Anchor href="https://plaid.com/how-it-works-for-consumers/" inline>
                                {LiteralsService.getLiteral('Onboarding.connectAccounts.bullets[4][1]')}
                            </Anchor>
                            {LiteralsService.getLiteral('Onboarding.connectAccounts.bullets[4][2]')}
                        </Typography>
                    </li>
                </ul>
            </>
        }
        linkName={LiteralsService.getLiteral('Onboarding.connectAccounts.footer')}
        link="https://plaid.com/how-it-works-for-consumers/"
    />
);

export default function WhyShouldYouConnectTooltip({ withText = false }: { withText?: boolean }): JSX.Element {
    return withText ? (
        <div className={styles.container}>
            <Typography variant={TypographyVariants.CAPTION}>
                {LiteralsService.getLiteral('Onboarding.connectAccounts.whyShouldYouConnect')}
            </Typography>
            {tooltip}
        </div>
    ) : (
        tooltip
    );
}
